/* F01: correct one cart-line promise; never change catalogue, quantities or codes. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.RevalF01CartPromise) {
    root.RevalF01CartPromise = api;
    api.mount(root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var VARIANT = '51418024739111';
  var TEXT = 'Despacho estimado en 5–10 días hábiles. Envío exprés; el tránsito y la entrega dependen de la paquetería y el destino.';
  var PENDING_KEY = 'reval-f01-delivery-notice-v1';

  function isTarget(item) { return String(item.variant_id || item.id) === VARIANT; }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function stable(value) {
    if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) {
      return JSON.stringify(key) + ':' + stable(value[key]);
    }).join(',') + '}';
    return JSON.stringify(value);
  }
  function problem(code, message) { var error = new Error(message); error.code = code; return error; }
  function assertCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) {
      return !item.key || !Number.isInteger(item.quantity) || item.quantity < 1;
    })) throw problem('invalid_cart', 'No pudimos leer el carrito completo. Vuelve a intentarlo.');
  }
  function correctedProperties(item) {
    var props = clone(item.properties || {});
    props.Entrega = TEXT;
    return props;
  }
  function itemSignature(item) {
    var record = {};
    ['variant_id', 'id', 'quantity', 'properties', 'selling_plan_allocation', 'parent_relationship',
      'price', 'original_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price',
      'total_discount', 'discounts', 'line_level_discount_allocations', 'line_level_total_discount'].forEach(function (key) {
      if (key in item) record[key] = item[key];
    });
    record.properties = record.properties || {};
    return stable(record);
  }
  function cartSignature(cart) {
    var record = { items: cart.items.map(itemSignature).sort() };
    ['item_count', 'currency', 'note', 'attributes', 'total_price', 'original_total_price',
      'items_subtotal_price', 'total_discount', 'cart_level_discount_applications', 'discount_codes'].forEach(function (key) {
      if (key in cart) record[key] = cart[key];
    });
    return stable(record);
  }
  function preflight(cart) {
    assertCart(cart);
    var signatures = new Map();
    cart.items.filter(isTarget).forEach(function (item) {
      // The approved migration changes Entrega only. A distinct public legacy field
      // must not silently survive into checkout with a conflicting promise.
      var legacy = (item.properties || {})['Entrega estimada'];
      if (legacy && legacy !== TEXT) throw problem('legacy_property', 'Esta línea contiene otra promesa de entrega que necesita revisión. No la modificamos ni continuamos al pago.');
      var signature = stable([correctedProperties(item), item.selling_plan_allocation || null, item.parent_relationship || null]);
      var stale = (item.properties || {}).Entrega !== TEXT;
      if (signatures.has(signature) && (stale || signatures.get(signature))) throw problem('merge_risk', 'Hay dos líneas de Puffer fucsia que podrían unirse al corregir el plazo. No modificamos esas líneas. Revisa el carrito antes de continuar.');
      signatures.set(signature, stale);
    });
  }

  function createController(io) {
    var tail = Promise.resolve();
    var flight = null;
    var aliases = Object.create(null);
    function enqueue(work) {
      var task = tail.then(work);
      tail = task.catch(function () {});
      return task;
    }
    function resolveKey(key) {
      var count = 0;
      while (aliases[key] && count++ < 100) key = aliases[key];
      return key;
    }
    async function run() {
      var cart = await io.getCart();
      preflight(cart);
      var changed = 0;
      var maximum = cart.items.length;
      for (var n = 0; n < maximum; n++) {
        var stale = cart.items.find(function (item) { return isTarget(item) && (item.properties || {}).Entrega !== TEXT; });
        if (!stale) return { cart: cart, changed: changed };
        // Re-read immediately before each write. Ajax Cart has no server-side CAS.
        var fresh = await io.getCart();
        assertCart(fresh);
        if (cartSignature(fresh) !== cartSignature(cart) || !fresh.items.some(function (item) { return item.key === stale.key; })) {
          throw problem('cart_drift', 'El carrito cambió mientras revisábamos el plazo. Vuelve a intentarlo con el carrito actualizado.');
        }
        preflight(fresh);
        var expected = clone(fresh);
        var index = fresh.items.findIndex(function (item) { return item.key === stale.key; });
        expected.items[index].properties = correctedProperties(fresh.items[index]);
        if (io.onChangeStarted) io.onChangeStarted();
        var response = await io.changeItem({
          id: fresh.items[index].key,
          quantity: fresh.items[index].quantity,
          properties: expected.items[index].properties
        });
        assertCart(response);
        var verified = await io.getCart();
        assertCart(verified);
        if (cartSignature(verified) !== cartSignature(expected)) {
          throw problem('verification_failed', 'No pudimos confirmar que el carrito conserve todas sus líneas y condiciones. Revisa el carrito antes de continuar; no repetimos el cambio automáticamente.');
        }
        var replacement = verified.items.find(function (item) { return itemSignature(item) === itemSignature(expected.items[index]); });
        if (replacement && replacement.key !== stale.key) aliases[stale.key] = replacement.key;
        changed++;
        cart = verified;
        if (io.onCorrected) io.onCorrected(cart);
      }
      if (cart.items.some(function (item) { return isTarget(item) && (item.properties || {}).Entrega !== TEXT; })) {
        throw problem('unstable_cart', 'El carrito cambió durante la revisión. Vuelve a intentarlo.');
      }
      return { cart: cart, changed: changed };
    }
    return {
      sanitize: function () {
        if (flight) return flight;
        flight = enqueue(run);
        var current = flight;
        current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
        return current;
      },
      coordinate: enqueue,
      resolveKey: resolveKey
    };
  }

  // This gate is independently testable. Confirming does not resume until a fresh
  // read verifies that no new correction is needed while the notice was open.
  function createGate(controller, state, confirm, present) {
    var flight = null;
    return function (resume) {
      if (flight) return flight;
      flight = (async function () {
        for (var attempt = 0; attempt < 3; attempt++) {
          var result = await controller.sanitize();
          if (result.changed) state.setPending(true);
          if (!result.cart.items.some(isTarget)) state.setPending(false);
          present(result.cart);
          if (state.getPending()) {
            if (!await confirm()) return false;
            state.setPending(false);
            continue;
          }
          await resume();
          return true;
        }
        throw problem('repeated_change', 'El plazo volvió a cambiar. Revisa el carrito antes de continuar.');
      })();
      var current = flight;
      current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
      return current;
    };
  }

  function mount(win) {
    var doc = win.document;
    var pending = false;
    var latestCart = null;
    var dialog = null;
    var refreshFlight = null;
    var renderWaiter = null;
    var bypassForm = null;
    var bypassLink = null;
    try { pending = win.sessionStorage.getItem(PENDING_KEY) === '1'; } catch (_) {}
    var state = {
      getPending: function () { return pending; },
      setPending: function (value) {
        pending = value;
        try { if (value) win.sessionStorage.setItem(PENDING_KEY, '1'); else win.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
      }
    };
    function endpoint(path) { return (win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/') + path; }
    async function request(path, data) {
      var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
      var abort = typeof win.AbortController === 'function' ? new win.AbortController() : null;
      var timeout = abort ? win.setTimeout(function () { abort.abort(); }, 12000) : null;
      if (abort) options.signal = abort.signal;
      if (data) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(data);
      }
      try {
        var response = await win.fetch(endpoint(path), options);
        if (!response.ok) throw new Error('Cart request failed');
        return await response.json();
      } catch (_) {
        throw problem('network_error', 'No pudimos verificar el plazo en el carrito. Vuelve a intentarlo antes de continuar al pago.');
      } finally { if (timeout) win.clearTimeout(timeout); }
    }
    function notice(message) {
      doc.querySelectorAll('[data-reval-f01-cart-notice]').forEach(function (node) {
        node.textContent = message || '';
        node.hidden = !message;
        node.style.cssText = 'margin:12px 0;padding:12px;border:1px solid currentColor;font-size:13px;line-height:1.5;white-space:normal;';
      });
    }
    function present(cart) {
      var previouslyAffected = latestCart && latestCart.items.some(isTarget);
      latestCart = cart;
      var affected = cart.items.some(isTarget);
      if (win.RevalF01SharedCopy && typeof win.RevalF01SharedCopy.updateCart === 'function') win.RevalF01SharedCopy.updateCart(affected);
      doc.querySelectorAll('[data-reval-f01-accelerated-container]').forEach(function (node) {
        node.hidden = affected;
        node.inert = affected;
      });
      doc.querySelectorAll('[data-reval-f01-accelerated-note]').forEach(function (node) { node.hidden = !affected; });
      if (!affected) {
        if (previouslyAffected && cart.items.length) {
          var states = cart.items.map(function (item) {
            var value = String((item.properties || {}).Entrega || (item.properties || {})['_Reval entrega'] || '');
            return /24-48/i.test(value) ? 'express' : (/5-10/i.test(value) ? 'standard' : 'unknown');
          });
          var allExpress = states.every(function (value) { return value === 'express'; });
          var allStandard = states.every(function (value) { return value === 'standard'; });
          doc.querySelectorAll('[data-reval-cart-delivery-heading]').forEach(function (node) { node.textContent = 'Entrega DHL'; });
          doc.querySelectorAll('[data-reval-cart-delivery-benefit]').forEach(function (node) { node.textContent = allExpress ? '24-48h Reval' : (allStandard ? '5-10 días' : 'Tiempo según modelo'); });
          doc.querySelectorAll('[data-reval-cart-delivery-summary]').forEach(function (node) { node.textContent = allExpress ? 'Entrega 24-48h por DHL Express' : (allStandard ? 'Entrega estimada 5-10 días hábiles' : 'Tiempo de entrega según cada modelo'); });
        }
        notice(''); return;
      }
      doc.querySelectorAll('[data-reval-cart-delivery-heading]').forEach(function (node) { node.textContent = 'Despacho'; });
      doc.querySelectorAll('[data-reval-cart-delivery-benefit]').forEach(function (node) { node.textContent = 'Despacho según variante'; });
      doc.querySelectorAll('[data-reval-cart-delivery-summary]').forEach(function (node) { node.textContent = 'Puffer fucsia: ' + TEXT; });
      doc.querySelectorAll('[data-reval-variant-id="' + VARIANT + '"] [data-reval-f01-delivery-property]').forEach(function (node) {
        node.textContent = 'Entrega: ' + TEXT;
      });
      notice((pending ? 'Actualizamos el plazo de Puffer fucsia. ' : 'Puffer fucsia: ') + TEXT + (pending ? ' Revísalo antes de continuar al pago.' : ''));
    }
    function showNotice(error) {
      if (dialog) return Promise.resolve(false);
      return new Promise(function (resolve) {
        var element = doc.createElement('dialog');
        dialog = element;
        element.setAttribute('aria-label', error ? 'Revisa el carrito' : 'Plazo actualizado de Puffer fucsia');
        element.style.cssText = 'width:min(90vw,36rem);max-height:85vh;overflow:auto;padding:24px;border:1px solid #333;background:#fff;color:#161616;line-height:1.5;';
        var title = doc.createElement('h2');
        title.style.cssText = 'font-size:20px;letter-spacing:normal;';
        title.textContent = error ? 'Revisa el carrito' : 'Actualizamos el plazo de Puffer fucsia';
        var description = doc.createElement('p');
        description.textContent = error ? error.message : TEXT;
        element.appendChild(title);
        element.appendChild(description);
        function close(result) { if (element.open) element.close(); element.remove(); dialog = null; resolve(result); }
        if (!error) {
          var proceed = doc.createElement('button');
          proceed.type = 'button'; proceed.className = 'btn';
          proceed.textContent = 'He leído el plazo. Continuar';
          proceed.addEventListener('click', function () { close(true); });
          element.appendChild(proceed);
        }
        var back = doc.createElement('button');
        back.type = 'button'; back.className = 'btn btn--secondary'; back.style.margin = '12px 0 0';
        back.textContent = 'Volver al carrito';
        back.addEventListener('click', function () { close(false); });
        element.appendChild(back);
        element.addEventListener('cancel', function (event) { event.preventDefault(); close(false); });
        doc.body.appendChild(element);
        if (typeof element.showModal === 'function') element.showModal();
        else {
          element.setAttribute('open', '');
          element.style.position = 'fixed'; element.style.top = '10vh'; element.style.zIndex = '2147483647';
        }
        back.focus();
      });
    }
    var controller = createController({
      getCart: function () { return request('cart.js'); },
      changeItem: function (payload) { return request('cart/change.js', payload); },
      onChangeStarted: function () { state.setPending(true); },
      onCorrected: function (cart) {
        state.setPending(true);
        present(cart);
      }
    });
    function refresh() {
      if (refreshFlight) return refreshFlight;
      refreshFlight = (async function () {
        // Drain earlier theme requests before waiting for freshly rebound line keys.
        await controller.coordinate(function () {});
        if (!win.theme || !win.theme.CartForm || !doc.querySelector('[data-reval-f01-cart-form]')) return;
        await new Promise(function (resolve, reject) {
          // Impulse MAIN renders the drawer form on /cart but does not instantiate
          // it there (theme.js initDrawers). Wait only for the native active form.
          var activeForm = doc.body.classList.contains('template-cart')
            ? doc.getElementById('CartPageForm')
            : (win.theme.settings && win.theme.settings.cartType === 'drawer' ? doc.getElementById('CartDrawerForm') : null);
          if (!activeForm) { resolve(); return; }
          var forms = new Set([activeForm]);
          var timer = win.setTimeout(function () {
            renderWaiter = null;
            reject(problem('render_failed', 'No pudimos actualizar la vista del carrito. Recarga el carrito antes de continuar.'));
          }, 8000);
          renderWaiter = function (form) {
            forms.delete(form);
            if (!forms.size) { win.clearTimeout(timer); renderWaiter = null; resolve(); }
          };
          doc.dispatchEvent(new win.CustomEvent('cart:build'));
        });
      })();
      var current = refreshFlight;
      current.then(function () { if (refreshFlight === current) refreshFlight = null; }, function () { if (refreshFlight === current) refreshFlight = null; });
      return current;
    }
    function fail(error) {
      notice(error.message || 'No pudimos revisar el carrito. Vuelve a intentarlo.');
      return showNotice(error);
    }
    function passiveSanitize() {
      return controller.sanitize().then(async function (result) {
        present(result.cart);
        if (result.changed) await refresh();
        return result;
      }).catch(function (error) { notice(error.message); });
    }
    var checkoutGate = createGate(controller, state, function () { return showNotice(); }, present);
    function route(resume) {
      checkoutGate(function () { return refresh().then(resume); }).catch(fail);
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }

    win.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-reval-f01-cart-form]')) return;
      if (bypassForm === form) { bypassForm = null; return; }
      var submitter = event.submitter || form.querySelector('[name="checkout"]');
      if (submitter && submitter.name && submitter.name !== 'checkout') return;
      stop(event);
      route(function () {
        bypassForm = form;
        // requestSubmit retains the native action, method, submitter and terms handler.
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else if (submitter) submitter.click();
        bypassForm = null;
      });
    }, true);
    win.addEventListener('click', function (event) {
      var element = event.target && event.target.closest ? event.target : null;
      if (!element) return;
      var accelerated = element.closest('[data-reval-f01-accelerated-container]');
      if (accelerated && latestCart && latestCart.items.some(isTarget)) { stop(event); notice('Usa «Continuar al pago seguro» para revisar el despacho de Puffer fucsia.'); return; }
      var link = element.closest('a[href]');
      if (!link || bypassLink === link) return;
      var url;
      try { url = new win.URL(link.href, win.location.href); } catch (_) { return; }
      if (url.origin !== win.location.origin || !/\/checkouts?(?:\/|$)/.test(url.pathname)) return;
      stop(event);
      var newTab = event.ctrlKey || event.metaKey || event.shiftKey;
      route(function () {
        bypassLink = link;
        var target = link.getAttribute('target');
        if (newTab) link.setAttribute('target', '_blank');
        link.click();
        if (newTab) { if (target === null) link.removeAttribute('target'); else link.setAttribute('target', target); }
        bypassLink = null;
      });
    }, true);

    function installThemeCoordination() {
      var theme = win.theme;
      if (!theme || !theme.cart || theme.cart.revalF01Coordinated) return;
      theme.cart.revalF01Coordinated = true;
      var update = theme.cart._updateCart;
      theme.cart._updateCart = function (params) {
        var owner = this;
        return controller.coordinate(function () {
          // Existing quantity listeners can briefly retain the old line key.
          var next = Object.assign({}, params);
          if (/\/cart\/change(?:\.js)?(?:\?|$)/.test(next.url || '')) {
            try { var data = JSON.parse(next.data); if (data.id) data.id = controller.resolveKey(data.id); next.data = JSON.stringify(data); } catch (_) {}
          }
          return update.call(owner, next);
        });
      };
      var markup = theme.cart.getCartProductMarkup;
      theme.cart.getCartProductMarkup = function () {
        var owner = this;
        return controller.coordinate(function () { return markup.call(owner); });
      };
      if (theme.CartForm && theme.CartForm.prototype.cartMarkup) {
        var render = theme.CartForm.prototype.cartMarkup;
        theme.CartForm.prototype.cartMarkup = function () {
          var value = render.apply(this, arguments);
          if (latestCart) present(latestCart);
          if (renderWaiter) renderWaiter(this.form);
          return value;
        };
      }
    }
    function ready() {
      installThemeCoordination();
      if (doc.getElementById('CartPageForm')) passiveSanitize();
    }
    doc.addEventListener('drawerOpen.CartDrawer', passiveSanitize);
    doc.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) present(event.detail.cart);
      passiveSanitize();
    });
    doc.addEventListener('ajaxProduct:added', function () {
      passiveSanitize();
    });
    win.addEventListener('pageshow', function (event) { if (event.persisted && doc.getElementById('CartPageForm')) passiveSanitize(); });
    doc.addEventListener('DOMContentLoaded', ready, { once: true });
    installThemeCoordination();
    if (doc.readyState === 'complete') ready();
    api.sanitize = passiveSanitize;
  }
  var api = { variantId: VARIANT, text: TEXT, isTarget: isTarget, correctedProperties: correctedProperties,
    cartSignature: cartSignature, createController: createController, createGate: createGate, mount: mount };
  return api;
});
